// e.g ([n, n, n], 2) => [[n, n], [n]]
export const splitArrayElementsInRows = <T>(arr: T[], itemsInARow: number): T[][] => {
  const rowsCounts = Math.floor(arr.length / itemsInARow);

  return new Array(rowsCounts) // create array with rowsCounts leghth.
    .fill(undefined) // .fill is required to make an array iterable via .map
    .map((_n, rowIndex) => arr.slice(rowIndex * itemsInARow, (rowIndex + 1) * itemsInARow));
};
